import { Component } from '@angular/core';

@Component({
  selector: 'dl-sidebar-content',
  templateUrl: './sidebar-content.component.html',
  styleUrls: ['./sidebar-content.component.css'],
})
export class DlSidebarContentComponent {}
